export default __webpack_public_path__ + "static/media/SmartBrain.ad213d84.PNG";